import { parseAsStringLiteral, useQueryState } from 'nuqs'
import useSWR from 'swr'

import { PageHeader } from '@/components/ds'
import { AdminDashboard } from '@/containers/AdminDashboard'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { AdminAuthActivity, AdminDashboardSummary } from '@/interfaces/AdminDashboard'

const PERIOD_OPTIONS = ['7', '30', '90'] as const

export default function AdminDashboardPage() {
  const [daysParam, setDaysParam] = useQueryState('days', parseAsStringLiteral(PERIOD_OPTIONS).withDefault('30'))

  const days = Number(daysParam) as 7 | 30 | 90

  const { data: summary } = useSWR<AdminDashboardSummary>('/api/v2/admin/dashboard', apiFetcher)
  const { data: activity } = useSWR<AdminAuthActivity>(`/api/v2/admin/auth-activity?days=${days}`, apiFetcher, {
    keepPreviousData: true,
  })

  useSetPageHeader({
    breadcrumbs: [{ href: '/admin', children: 'Administrace' }],
  })

  return (
    <>
      <title>Administrace</title>
      <div className="mx-auto w-full max-w-[1280px]">
        <PageHeader title="Administrace" description="Účty, uživatelé a aktivita napříč aplikací" />
        <AdminDashboard
          summary={summary}
          activity={activity}
          days={days}
          onDaysChange={(value) => setDaysParam(String(value) as (typeof PERIOD_OPTIONS)[number])}
        />
      </div>
    </>
  )
}
